import followers from '@meettry/ui-components/images/icons/white/icon_followers.svg';
import heart from '@meettry/ui-components/images/icons/white/icon_heart.svg';
import pin from '@meettry/ui-components/images/icons/white/icon_pin.svg';

export default {
  followers,
  heart,
  pin
};
